// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34NF4","productName":"Table_productName__3I2AQ"};